import gql from 'graphql-tag';

const INSTALLERS_GET_OS = gql`
  query getOs {
    getOsResponse
      @rest(
        type: "GetOs"
        path: "/installers/os/"
        method: "GET"
      ) {
      id
      name
    }
  }
`;

const INSTALLERS_GET_VERSIONS = gql`
  query getVersions {
    getVersionsResponse
      @rest(
        type: "GetVersions"
        path: "/installers/versions/"
        method: "GET"
      ) {
      id
      friendly_name
      frontend
      backend
      health
    }
  }
`;

const GET_PATCH_MESSAGE = gql`
  query getPatchMessage {
    getPatchMessageResponse
      @rest(
        type: "getPatchMessage"
        path: "/installers/patch_messages/"
        method: "GET"
      ) {
      message
    }
  }
`;


export default {
  INSTALLERS_GET_OS,
  INSTALLERS_GET_VERSIONS,
  GET_PATCH_MESSAGE
};